import Navbar from "../components/Navbar";
import "./RegistroEnviado.css";


const PoliticaCookies = () => {
  return (
    <>
      <Navbar />

      <main className="main textos-legales">

        <h1>Politica de cookies</h1>
        
      </main>
    </>
  );
};

export default PoliticaCookies;